import { Lightning, Router } from '@lightningjs/sdk'

import { getColor, grey50, grey920, grey960, primary500 } from '../../constants/colors'
import { UniNeueBold } from '../../constants/fonts'
import { BORDER_RADIUS } from '../../constants/general'
import { getIcon } from '../../utils/image'
import { captureClick, SEGMENT_TRACK_EVENTS } from '../../utils/segmentAnalytics'
import SpeechComp from '../speechComp/speechComp'

export default class SettingsMenuItem extends SpeechComp {
  private _route: string
  private _routeState: object
  private _menuItemId: number

  static _template() {
    return {
      w: 808,
      h: 84,
      rect: true,
      clipping: true,
      collision: true,
      color: getColor(primary500),
      shader: {
        type: Lightning.shaders.RoundedRectangle,
        radius: BORDER_RADIUS,
      },
      flexItem: {
        marginBottom: 24,
      },
      Fill: {
        x: -1,
        y: -1,
        w: (w) => w + 2,
        h: (h) => h + 2,
        rect: true,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: BORDER_RADIUS,
          fillColor: getColor(grey920),
        },
      },
      Wrapper: {
        w: (w) => w,
        h: (h) => h,
        flex: {
          alignItems: 'center',
          direction: 'row',
        },
        Label: {
          x: 32,
          w: 744,
          text: {
            text: '',
            textColor: getColor(grey50),
            fontSize: 32,
            fontFace: UniNeueBold,
            maxLines: 1,
            maxLinesSuffix: '...',
            wordWrapWidth: 744,
          },
        },
        Icon: {
          color: getColor(grey50),
          texture: Lightning.Tools.getSvgTexture(getIcon('icon-caret-right'), 32, 32),
        },
      },
    }
  }

  set label(v: string) {
    this.tag('Label').patch({ text: v })
  }

  get label() {
    return this.tag('Label').text.text
  }

  set route(v: string) {
    this._route = v
  }

  set routeState(v: object) {
    this._routeState = v
  }

  get wrapper() {
    return this.tag('Wrapper')
  }

  get fill() {
    return this.tag('Fill')
  }

  get speechText(): string {
    return this.label
  }

  set menuItemId(v: number) {
    this._menuItemId = v
  }

  get menuItemId() {
    return this._menuItemId
  }

  _focus() {
    this.focusItem(true)
    this.speak()
  }

  _unfocus() {
    this.focusItem(false)
  }

  _handleEnter() {
    void captureClick(SEGMENT_TRACK_EVENTS.ButtonClicked, this.label, 'Settings')

    if (this._route) {
      Router.navigate(this._route, this._routeState ?? null)
    }
  }

  focusItem(isFocused: boolean) {
    this.fill.patch({
      x: isFocused ? 6 : -1,
      w: isFocused ? (w) => w - 5 : (w) => w + 2,
      shader: { fillColor: isFocused ? getColor(grey50) : getColor(grey920) },
    })

    this.wrapper.patch({
      Label: { text: { textColor: isFocused ? getColor(grey960) : getColor(grey50) } },
      Icon: { color: isFocused ? getColor(grey960) : getColor(grey50) },
    })
  }

  _handleHover() {
    this.fireAncestors('$updateFocusByHover', this)
    this._focus()
  }

  _handleUnhover() {
    this._unfocus()
  }

  _handleClick() {
    this._handleEnter()
  }
}
